<template>
  <div class="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
    <el-button
      class="!m-0 w-full sm:w-auto"
      @click="onDecline"
    >
      {{ $t('REGISTER.DECLINE_BTN') }}
    </el-button>

    <el-button
      class="!m-0 w-full sm:w-auto"
      type="primary"
      @click="onConfirm"
    >
      {{ $t('REGISTER.AGREE_BTN') }}
    </el-button>
  </div>
</template>

<script setup lang="ts">
const emits = defineEmits(["decline", "confirm"]);

const {
  $t,
} = useNuxtApp();

function onDecline() {
  emits("decline");
}

function onConfirm() {
  emits("confirm");
}
</script>
